import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  wrapper: {
    width: '590px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '-0.016em',
  },
  row: {
    marginTop: '24px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: '40px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
};

export default styles;
